import Vue from 'vue'
import VueRouter from 'vue-router'
import PageNotFound from '../views/PageNotFoundView.vue'
import LoginView from '../views/LoginView.vue'
import UploadView from '../views/UploadView.vue'
import OnLineView from '../views/OnLineView.vue'
import SubscribesListView from '../views/SubscribesListView.vue'
import CallHistoryView from '../views/CallHistoryView.vue'
import AccountView from '../views/AccountView.vue'
import ReportsView from '../views/ReportsView.vue'
import SettingsView from '../views/SettingsView.vue'
import AgentView from '../views/AgentView.vue'
import AdminView from '../views/AdminView.vue'
import RessetPassView from '../views/ResetPasswordView.vue'
import PaySuccessfulView from '../views/PaySuccessfulView.vue'
import PayFailedView from '../views/PayFailedView.vue'
import LogsView from '../views/LogsView.vue'
import Auth from '@/services/auth.service'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
  },

  {
    path: '/resset-password/:token',
    name: 'ressetPass',
    component: RessetPassView,
  },

  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/upload/:page',
    name: 'upload',
    component: UploadView,
    meta: { requiresAuth: true },
  },
  {
    path: '/on-line-users',
    name: 'onLineUsers',
    component: OnLineView,
    meta: { requiresAuth: true },
  },
  {
    path: '/subscribes-list',
    name: 'subscribesList',
    component: SubscribesListView,
    meta: { requiresAuth: true },
  },
  {
    path: '/call-history',
    name: 'callHistory',
    component: CallHistoryView,
    meta: { requiresAuth: true },
  },
  {
    path: '/account',
    name: 'account',
    component: AccountView,
    meta: { requiresAuth: true },
  },
  {
    path: '/reports',
    name: 'reports',
    component: ReportsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings/:page',
    name: 'settings',
    component: SettingsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/agent/:page',
    name: 'agent',
    component: AgentView,
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/:page',
    name: 'admin',
    component: AdminView,
    meta: { requiresAuth: true },
  },
 

  {
    path: '/successPage',
    name: 'paySuccess',
    component: PaySuccessfulView,
    meta: { requiresAuth: true },
  },

  {
    path: '/failedPage',
    name: 'payFailed',
    component: PayFailedView,
    meta: { requiresAuth: true },
  },
  {
    path: '/logs',
    name: 'logs',
    component: LogsView,
    meta: { requiresAuth: true },
  },

  { path: '*', component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !Auth.checkAuth()) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
})

export default router
